import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { catchError, map, Observable, of } from "rxjs";
import {
    GetKeywordTypeAheadResponseType
} from "@app/modules/tf-typeahead/models/types/GetKeywordTypeAheadResponseType";
import { ApiErrorType } from "@app/models/types/api-error.type";

@Injectable()
export class TfTypeaheadService {

    API_URL = '/api/magellan/product/getKeywordTypeAhead';

    constructor(
        private http: HttpClient
    ) {
    }

    getSuggestions(term: string, productType: string): Observable<string[]> {
        if (term === '') {
            return of([]);
        }

        let productTypeProcessed = "";
        switch (productType) {
            case "ge":
                productTypeProcessed = "ge";
                break;
            case "gx":
                productTypeProcessed = "gx";
                break;
            case "sg-assay":
            case "snp":
                productTypeProcessed = "snp";
                break;
            case "cnv":
            case "cn-assay":
                productTypeProcessed = "cnv";
                break;
            case "mr-assay":
            case "microrna":
                productTypeProcessed = "mirna";
                break;
            default:
                productTypeProcessed = "taqman";
                break;
        }

        let queryParams = new HttpParams();
        queryParams = queryParams.append("keyword", term);
        queryParams = queryParams.append("productType", productTypeProcessed);

        return this.http.get<GetKeywordTypeAheadResponseType>(this.API_URL, {params: queryParams}).pipe(
            map((response) => {

                if (this.isError(response)) {
                    return [];
                }

                return response.suggest.blendedinfixsuggester[term.toLocaleLowerCase()].suggestions.map((doc) => {
                    return doc.term;
                });

            }),
            catchError(() => {
                return of([]);
            })
        );

    }

    isError(response: any): response is ApiErrorType {
        return 'details' in response && 'message' in response && 'status' in response && 'timeStamp' in response;
    }

}
